import React from "react";
import { POLICY_STATUS_CFG } from "./PolicyLifecyclePanel";

// Review & expiration calendar (prototype tab 2): every non-archived policy's next review and
// expiration dates, grouped by month, overdue first.
const PolicyReviewCalendar = ({ policyDocs, titleOf }) => {
    const now = new Date();
    const entries = policyDocs
        .filter(d => d.lifecycleStatus !== "Archived")
        .flatMap(d => [
            d.nextReviewDate ? { kind: "Review", date: new Date(d.nextReviewDate), d } : null,
            d.expirationDate ? { kind: "Expiration", date: new Date(d.expirationDate), d } : null,
        ].filter(Boolean))
        .sort((a, b) => a.date - b.date);

    if (entries.length === 0)
        return <p className="text-xs text-gray-400">No scheduled reviews or expirations — publish a policy to put it on the calendar.</p>;

    const groups = entries.reduce((acc, e) => {
        const key = e.date < now ? "Overdue" : e.date.toLocaleDateString(undefined, { year: "numeric", month: "long" });
        (acc[key] = acc[key] || []).push(e);
        return acc;
    }, {});

    return (
        <div className="space-y-4">
            {Object.entries(groups).map(([month, items]) => (
                <div key={month}>
                    <div className={`text-xs font-semibold uppercase tracking-wide mb-1.5 ${month === "Overdue" ? "text-red-600" : "text-gray-500"}`}>{month}</div>
                    <div className="bg-white border border-gray-200 rounded-xl divide-y divide-gray-100">
                        {items.map((e, i) => {
                            const cfg = POLICY_STATUS_CFG[e.d.lifecycleStatus] || POLICY_STATUS_CFG.Published;
                            const isOverdue = e.date < now;
                            return (
                                <div key={`${e.d.id}-${e.kind}-${i}`} className="px-4 py-2 flex items-center gap-3 text-xs">
                                    <span className={`font-medium w-24 ${isOverdue ? "text-red-600" : "text-gray-700"}`}>{e.date.toLocaleDateString()}</span>
                                    <span className={`px-1.5 py-0.5 rounded-full text-[10px] font-medium border ${e.kind === "Expiration" ? "bg-red-50 text-red-700 border-red-200" : "bg-indigo-50 text-indigo-700 border-indigo-200"}`}>{e.kind}</span>
                                    <span className="text-gray-700 truncate">{titleOf(e.d)} <span className="text-gray-400">v{e.d.version}</span></span>
                                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium ${cfg.cls}`}>{cfg.label}</span>
                                    {e.d.ownerName && <span className="text-gray-400 ml-auto">owner: {e.d.ownerName}</span>}
                                </div>
                            );
                        })}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PolicyReviewCalendar;
